import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Constants from "../../AppConstants/Constants";
import Layout from "../../Layouts/LayoutMain";
import Items from "../../Components/Common/Items";
import { PageTitle } from "../../Components/Common/PageTitle";
import { getLineHaulItems, selectProduct } from "../../Store/Catalog/Actions";

class LineHaulItems extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: false,
            crossSellParentProduct: {},
            lineHaulItemQuantity: 1
        };

        this.showDetails = this.showDetails.bind(this);
        this.getCrossSellProducts = this.getCrossSellProducts.bind(this);
        this.updateLineHaulItemQuantity = this.updateLineHaulItemQuantity.bind(this);
    }

    componentWillMount() {
        const { getLineHaulItems, lineHaulItems, config: { LINEHAUL_CATEGORY_ID }, i18n, activeCurrency } = this.props;

        if (!lineHaulItems || lineHaulItems.length === 0 || lineHaulItems[0].locale !== i18n.locale || lineHaulItems[0].currencyCode !== activeCurrency.currencyCode) {
            getLineHaulItems(LINEHAUL_CATEGORY_ID, true);
        }
    }

    getCrossSellProducts(data) {
        this.setState({ parentProduct: data });
    }

    showDetails(data, qty) {
        this.props.selectProduct(data);
        this.props.history.push(`${Constants.ENDPOINTS.LINEHAUL_DETAILS}?product=${data.id}&quantity=${qty}`);
    }

    updateLineHaulItemQuantity(quantity) {
        this.setState({ lineHaulItemQuantity: quantity });
    }

    renderSections(sections, categoryName) {
        return _.map(sections, (items, kitCategoryTitle) => (
            <Items key={kitCategoryTitle} items={items} accessorySubTitle={kitCategoryTitle} filter={categoryName} addToCart={true} showDetails={this.showDetails} getCrossSellProducts={this.getCrossSellProducts} />
        ));
    }

    render() {
        const { isAuthenticated, lineHaulItems } = this.props;
        let categoryName = "";
        let sections = {};

        if (lineHaulItems && lineHaulItems.length > 0) {
            categoryName = lineHaulItems[0].category.name;

            const filteredItems = _.filter(lineHaulItems, item => item.productSpecifications && item.productSpecifications.length > 0);
            const groupedItems = _.orderBy(filteredItems, [item => item.productSpecifications[item.productSpecifications.map(e => { return e.specificationAttributeName }).indexOf("VTrack Sub Categories")].displayOrder, item => item.displayOrder]);
            sections = _.groupBy(groupedItems, item => item.productSpecifications[item.productSpecifications.map(e => { return e.specificationAttributeName }).indexOf("VTrack Sub Categories")].valueRaw);
        }

        return (
            <Layout isAuthenticated={isAuthenticated}>
                {
                    Object.keys(sections).length > 0 ?
                        <div className="accessories-container">
                            <PageTitle title={categoryName} />
                            {this.renderSections(sections, categoryName)}
                        </div>
                        :
                        <Items
                            items={lineHaulItems}
                            filter={categoryName}
                            addToCart={true}
                            showDetails={this.showDetails}
                            getCrossSellProducts={this.getCrossSellProducts}
                            openPlanModal={this.openPlanModal}
                            updateDeviceQuantity={this.updateLineHaulItemQuantity}
                        />
                }
                
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        activeCurrency: state.activeCurrency,
        config: state.config,
        lineHaulItems: state.lineHaulItems
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getLineHaulItems: getLineHaulItems,
        selectProduct: selectProduct
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LineHaulItems);